import { render, staticRenderFns } from "./DimensionModal.vue?vue&type=template&id=2e604c7e&scoped=true"
import script from "./DimensionModal.vue?vue&type=script&lang=js"
export * from "./DimensionModal.vue?vue&type=script&lang=js"
import style0 from "./DimensionModal.vue?vue&type=style&index=0&id=2e604c7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e604c7e",
  null
  
)

export default component.exports